import {Component, Input, OnInit} from '@angular/core';
import {DossierIntervention} from 'app/models/dossier_intervention.model';
import {NomPiece} from 'app/models/nomPiece.model';
import {PieceEquipement} from 'app/models/pieceEquipement.model';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ModalConfirm} from '../../../shared/modal-confirm/modal-confirm.component';
import {UserService} from '../../../core/user/user.service';
import {DossierInterventionService} from '../../../services/dossier_intervention.service';
import {Croquis} from '../../../models/croquis.model';
import {Etage} from '../../../models/etage.model';
import {ModalDossierCroquis} from './modal-dossier-croquis/modal-dossier-croquis.component';
import html2canvas from 'html2canvas';
import {CroquisService} from '../../../services/croquis.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-dossier-croquis',
    templateUrl: './dossier-croquis.component.html',
    styleUrls: ['./dossier-croquis.component.scss']
})
export class DossierCroquisComponent implements OnInit {
    @Input() currentDossierIntervention: DossierIntervention;
    dossierCroquis: Croquis[] = [];
    nomsPieces: NomPiece[] = [];
    etages: Etage[] = [];

    constructor(
        private userService: UserService,
        private dossierService: DossierInterventionService,
        private dialog: MatDialog,
        private croquisService: CroquisService,
        private toastr: ToastrService
    ) {
    }

    get isAdmin(): boolean {
        return this.userService.getCurrentUser().role_id === 1;
    }

    ngOnInit(): void {
        this.getCroquis();
    }

    getCroquis(): void {
        this.dossierService.getCroquisForDossierIntervention(this.currentDossierIntervention.id).subscribe((result) => {
            this.dossierCroquis = result.croquis;
        });
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    store(): void {
        const dialogRef = this.openCroquisModal();
    }

    update(croquis: Croquis): void {
        const dialogRef = this.openCroquisModal();

        dialogRef.componentInstance.croquis = croquis;
    }

    destroy(croquis: Croquis): void {
        const dialogRef = this.dialog.open(ModalConfirm, {
            width: '50%',
        });
        dialogRef.componentInstance.confirmationMessage = 'Voulez-vous supprimer cet équipement de ce dossier?';
        dialogRef.afterClosed().subscribe((result) => {
            if(result === true) {
                // this.dossierService.destroyPieceForDossierIntervention(this.currentDossierIntervention.id, croquis).subscribe(()=>{
                //     this.getCroquis();
                // });
            }
        });
    }

    openCroquisModal(): MatDialogRef<ModalDossierCroquis> {
        const dialogRef = this.dialog.open(ModalDossierCroquis, {
            width: '75%',
        });

        dialogRef.componentInstance.idDossierIntervention = this.currentDossierIntervention.id;

        dialogRef.afterClosed().subscribe((result) => {
            this.getCroquis();
        });

        return dialogRef;
    }

    afficher_image(etage_id: number){
        this.croquisService.getSVGParEtage(etage_id).subscribe((svg) => {
            if(svg == ''){
                this.toastr.warning('Il n\'y a pas encore de croquis pour cet étage');
                return;
            }

            document.getElementById('croquis_image_svg_content').innerHTML = svg;
            const svgElement = document.getElementById('croquis_image_svg');

            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            html2canvas(svgElement).then(function(canvas) {
                const dataURL = canvas.toDataURL('image/png');
                const imgElement = document.createElement('img');
                imgElement.src = dataURL;

                document.getElementById('croquis_image_png').innerHTML = '';
                document.getElementById('croquis_image_png').appendChild(imgElement);

                // Pour télécharger
                const linkElement = document.createElement('a');
                linkElement.href = dataURL;
                linkElement.download = 'mon_plan.png';
                linkElement.click();

                document.getElementById('croquis_image_svg_content').innerHTML = '';
                document.getElementById('croquis_image_png').innerHTML = '';
            });
        });
    }
}
